module.exports = __webpack_public_path__ + "img/large_round.f32ed653.svg";